import axios from "axios";
import { BASE_URL } from "../constants/APIConstants";
import {
  apiRequest,
  authConfig,
  deleteResource,
  getResource,
} from "../api/http";

// TV shows
export function getShowList() {
  return getResource("/api/tv-shows/get-all-tv-shows-list");
}

/** Show (or podcast) details with its media. */
export function getTvShow(show_id) {
  return getResource(`/api/admin/get-episode-mediaId/${show_id}`, {
    select: (data) => (data.tvShowDetails !== null ? data.tvShowDetails : []),
    fallback: [],
  });
}

export function updateShow(obj, show_id) {
  return apiRequest("put", `/api/tv-shows/update-tv-show/${show_id}`, {
    data: obj,
  });
}

export function deleteShow(show_id) {
  return deleteResource(`/api/tv-shows/delete-tv-show/${show_id}`);
}

// Seasons
export function getSeasonList(tvshow_id) {
  return getResource(`/api/tv-shows/get-seasons-of-a-tv-show/${tvshow_id}`);
}

export function deleteSeason(season_id) {
  return deleteResource(`/api/seasons/delete-season/${season_id}`);
}

// Episodes
export function getEpisodeList(show_id) {
  return getResource(`/api/episodes/get-episode-list/${show_id}`);
}

export function getEpisode(epi_id) {
  return getResource(`/api/episodes/get-episode/${epi_id}`, {
    select: (data) => (data.episodeObj !== null ? data.episodeObj : []),
    fallback: [],
  });
}

export function updateEpisode(obj, episode_id) {
  return apiRequest("put", `/api/episodes/update-episode/${episode_id}`, {
    data: obj,
  });
}

export function deleteEpisode(episode_id, season_id) {
  return deleteResource(
    `/api/episodes/delete-episode/${episode_id}/${season_id}`
  );
}

// Creation endpoints reject on failure; callers check the `saved*` field.

export function createShow(generalInfo) {
  return apiRequest("post", "/api/tv-shows/create-tv-show", {
    data: generalInfo,
    rethrow: true,
  });
}

export function createSeason(show_id, generalInfo) {
  return apiRequest(
    "post",
    `/api/seasons/create-season-of-tv-show/${show_id}`,
    {
      data: generalInfo,
      rethrow: true,
    }
  );
}

/** Also used for podcast episodes. */
export function createEpisode(season_id, generalInfo) {
  return apiRequest(
    "post",
    `/api/episodes/create-episode-of-season/${season_id}`,
    { data: generalInfo, rethrow: true }
  );
}

// Media bookkeeping; resolve with the raw axios response (used by redux actions).

/** Stores the JW media id / duration on an episode (TV show or podcast). */
export function updateEpisodeMedia(episode_id, body) {
  return axios.patch(
    `${BASE_URL}/api/episodes/upload-media-id/${episode_id}`,
    body,
    authConfig()
  );
}

export function setShowTrailerMediaId(generalContent_id, body) {
  return axios.patch(
    `${BASE_URL}/api/tv-shows/upload-trailer-id/${generalContent_id}`,
    body,
    authConfig()
  );
}
